import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DataSourceTypes } from "./data-source.model";
import {
  dataSourceAdapter,
  dataSourcesFeatureKey,
  DataSourceState,
  initialDataSourceState,
} from "./data-source.reducer";

const selectDataSourceFeature = createFeatureSelector<DataSourceState>(
  dataSourcesFeatureKey,
);

export const selectDataSourceState = createSelector(
  selectDataSourceFeature,
  (state): DataSourceState => state ?? initialDataSourceState,
);

const { selectIds, selectEntities, selectAll, selectTotal } =
  dataSourceAdapter.getSelectors(selectDataSourceState);

export const selectDataSourceIDs = selectIds;
export const selectDataSourceEntities = selectEntities;
export const selectDataSources = selectAll;
export const selectDataSourceTotal = selectTotal;

export const selectChats = createSelector(selectDataSources, (dataSources) => {
  return dataSources?.filter((ds) => ds.source_type === DataSourceTypes.CHAT);
});

export const selectSurveys = createSelector(
  selectDataSources,
  (dataSources) => {
    return dataSources?.filter(
      (ds) => ds.source_type === DataSourceTypes.SURVEY,
    );
  },
);

export const selectDataSourcesLoading = createSelector(
  selectDataSourceState,
  (state) => state.loading,
);

export const selectReadyDataSourcesTotal = createSelector(
  selectDataSources,
  (dataSources) =>
    dataSources.filter((ds) => ds.fully_imported && !ds.stale_es_migration)
      .length,
);
